<body>
<div class="login-box">
  <div class="lottie-animation m-b-32">
    <ng-lottie [options]="options"> </ng-lottie>
  </div>
  <h2 class="auth-m-title">{{ "THANK_YOU_MESSAGE_SIGNUP" | translate }}</h2>
  <p class="login-desc m-b-32">
    {{ "VERIFICATION_LINK_SEND_TO" | translate }}<br />
    {{ eMail }}
  </p>
  <p class="login-desc-sm m-b-32">
    {{ "CHECK_MAIL_OR_CONTACT_SUPPORT" | translate }}
  </p>
  <button
    type="submit"
    class="btn blue-gredient-btn form-control w-100 justify-content-center mt-3"
    mat-button
    mat-flat-button
    routerLink="/"
  >
    {{ "GO_BACK_TO_LOGIN" | translate }}
  </button>
</div>
<img src="https://ct.capterra.com/capterra_tracker.gif?vid=2153285&vkey=9674b1d072f8d430391ab84ebda1e1cb" alt="capterra"/>
</body>
